// please don't change screen_id
export const screenInfoDetails = {
    CONTRACTING_HOME_SCREEN : {
       screen_id : '1_0001',
       screen_name : "Contracting Seeker Home Screen",
       route_pathname :"/seeker"
    },
    CONTRACT_RECORDS_SCREEN : {
       screen_id : '1_0002',
       screen_name : "Contract Records Screen",
       route_pathname :"/contractRecords"
    },
    SECONDARY_CONTRACTS_SCREEN : {
       screen_id : '1_0003',
       screen_name : "Secondary Contracts Screen",
       route_pathname :"/secondaryContracts"
    },
    MULTI_MODE_CONTRACTS_SCREEN : {
       screen_id : '1_0004',
       screen_name : "Multi Mode Contracts Screen",
       route_pathname :"/multiModeContracts"
    },
    VIEW_GENERATED_CONTRACTS_SCREEN : {
       screen_id : '1_0005',
       screen_name : "View Generated Contracts Screen",
       route_pathname :"/viewGeneratedContracts"
    },
    CONTRACTING_MIS_REPORT_SCREEN : {
       screen_id : '1_0006',
       screen_name : "Contracting MIS Report Screen",
       route_pathname :"/holistics"
    },
    DPL_DIESEL_PRICE_HIKE_REPORT_SCREEN : {
       screen_id : '1_0007',
       screen_name : "DPL Diesel Price Hike Report Screen",
       route_pathname :"/report/:type"
    },
    DPL_TRANSPORTER_PARTICIPATION_REPORT_SCREEN : {
       screen_id : '1_0008',
       screen_name : "DPL Transporter Participation Report Screen",
       route_pathname :"/report/:type"
    },
    CONTRACTING_DASHBOARD_REPORT_SCREEN : {
       screen_id : '1_0009',
       screen_name : "Contracting Dashboard Report Screen",
       route_pathname :"/gDashboard/:reportId"
    },
    DPL_NEW_CONTRACT_MONITORING_DASHBOARD_REPORT_SCREEN : {
       screen_id : '1_0010',
       screen_name : "DPL New Contract Monitoring Dashboard Report Screen",
       route_pathname :"/gDashboard/:reportId"
    },
    DPL_USER_DETAILS_REPORT_SCREEN : {
       screen_id : '1_0011',
       screen_name : "DPL User Details Report Screen",
       route_pathname :"/report/:type"
    },
    CONTRACTING_PROVIDER_HOME_SCREEN : {
       screen_id : '1_0012',
        screen_name : "Contracting Provider Home Screen",
       route_pathname :"/transporters"
    },
    RFQ_DETAILS_SCREEN : {
       screen_id : '1_0013',
       screen_name : "Rfq Details Screen",
       route_pathname :"/rfq/details/:id/:type"
    },
    RFQ_BIDS_SCREEN : {
       screen_id : '1_0014',
       screen_name : "Rfq Bids Screen",
       route_pathname :"/seeker/bids/:id/:type"
    },
    BIDS_TRANSPORTERS_LIST_SCREEN : {
       screen_id : '1_0015',
       screen_name : "Bids Transporters List Screen",
       route_pathname :"/seeker/bids/transporters/list/:id"
    },
    RFQ_VIEW_SCREEN : {
       screen_id : '1_0016',
       screen_name : "Rfq View Screen",
       route_pathname :"/rfq/view/:id/:serviceType/:type"
    },
    RFQ_CREATE_SCREEN : {
       screen_id : '1_0017',
       screen_name : "Rfq Create Screen",
       route_pathname :"/rfq/create/:id/:type/:isCopy"
    },
    RFQ_TYPE_SCREEN : {
       screen_id : '1_0018',
       screen_name : "Rfq Type Screen",
       route_pathname :"/rfq/type"
    },
    CREATE_NEW_CONTRACTS_SCREEN : {
       screen_id : '1_0019',
       screen_name : "Create New Contracts Screen",
       route_pathname :"/createNewContracts"
    },
    SCLEN_NEW_RFQ_DASHBOARD_SCREEN : {
      screen_id : '1_0020',
       screen_name : "New RFQ Dashboard Screen",
       route_pathname :"/nsr/rfq-dashboard"
    }

}

export const reportTypeMapping = {
    "123": screenInfoDetails.DPL_DIESEL_PRICE_HIKE_REPORT_SCREEN,
    "124": screenInfoDetails.DPL_TRANSPORTER_PARTICIPATION_REPORT_SCREEN,
    "172": screenInfoDetails.DPL_USER_DETAILS_REPORT_SCREEN,
}

export const gDashboardReportIdMapping = {
    "6f7f1693574c4ec2ac54ed35aa50c6da9916": screenInfoDetails.CONTRACTING_DASHBOARD_REPORT_SCREEN,
    "6f7f1693574c4ec2ac54ed35aa50c6da9954": screenInfoDetails.DPL_NEW_CONTRACT_MONITORING_DASHBOARD_REPORT_SCREEN
}
